import Input from './component';

export default Input;
